"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchTrafficEstimate = exports.searchTrafficEstimateResultSchema = exports.searchTrafficEstimateResultItemSchema = exports.searchTrafficEstimateArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.searchTrafficEstimateArgsSchema = zod_1.z.object({
    domain: zod_1.z
        .string()
        .describe('The domain to analyze traffic for. Supports flexible URL formats - protocol is optional and will be auto-normalized. Examples: "https://nike.com", "nike.com", "www.nike.com". The domain will be normalized to format like "nike.com" without protocol, path, or parameters.'),
    region: zod_1.z
        .string()
        .default('Global')
        .describe('The region to analyze traffic for. Use "Global" for worldwide traffic or specify a country name in natural language like "United States", "France", etc. Default is "Global".'),
    breakdownByCountry: zod_1.z
        .boolean()
        .default(false)
        .describe('When region is "Global", setting this to true returns traffic breakdown by country. Ignored when specific country is provided. Default is false.'),
    options: zod_1.z
        .object({
        failIfEmpty: zod_1.z
            .boolean()
            .default(true)
            .describe('Fail if the search returns no traffic data. Default to true.'),
    })
        .optional()
        .nullable()
        .describe('Search options'),
});
exports.searchTrafficEstimateResultItemSchema = zod_1.z.object({
    target_domain: zod_1.z.string().describe('The domain that was analyzed'),
    location: zod_1.z.string().describe('The region/country name for this traffic data'),
    language: zod_1.z.string().describe('The language code for this traffic segment'),
    organic_monthly_traffic_estimate: zod_1.z
        .number()
        .describe('Estimated monthly organic search traffic volume'),
    paid_monthly_traffic_estimate: zod_1.z
        .number()
        .describe('Estimated monthly paid search traffic volume'),
    paid_traffic_monthly_cost_estimate: zod_1.z
        .number()
        .describe('Estimated monthly cost of paid search traffic in USD'),
});
exports.searchTrafficEstimateResultSchema = zod_1.z.array(exports.searchTrafficEstimateResultItemSchema);
exports.searchTrafficEstimate = (0, common_1.createToolMetadata)({
    id: 'searchTrafficEstimate',
    displayName: 'Search Traffic Estimate',
    displayDescription: 'Get monthly search traffic estimates for any domain with optional regional breakdown. Analyzes both organic and paid search traffic volumes with cost estimates. Supports global analysis or country-specific data. Can provide traffic breakdown by country when analyzing global traffic. Uses SEO Review Tools API for accurate traffic estimation. Always returns an array of results.',
    category: 'search',
    color: common_1.BRAND_COLORS.WEB,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.WEB),
    icon: 'search',
    argsSchema: exports.searchTrafficEstimateArgsSchema,
}, exports.searchTrafficEstimateResultSchema);
